import React from 'react';
import { useNavigate } from 'react-router';
import { ChevronRight } from 'lucide-react';
import logo from '../assets/images/odaz_logo2.jpeg'

export default function PublicLayout({ children }) {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-premium-dark font-poppins text-gray-100 selection:bg-premium-gold/30 flex flex-col">
            {/* Navbar */}
            <nav className="fixed w-full z-50 bg-premium-teal/80 backdrop-blur-md border-b border-white/10 transition-all duration-500">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-20">
                        <div className="flex items-center">
                            {/* Logo / Brand */}
                            <div className="flex-shrink-0 cursor-pointer group" onClick={() => navigate('/')}>
                                <div className="flex flex-row">
                                    <img src={logo} alt="Logo" className="w-12 h-12 rounded-full" />
                                    <span className="text-3xl font-black text-white tracking-tighter transition-all duration-300 group-hover:tracking-normal">
                                        DAZ <span className="text-premium-gold">APP</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="hidden md:block">
                            <div className="ml-10 flex items-center space-x-8">
                                <a href="/#features" className="text-gray-300 hover:text-premium-gold px-3 py-2 rounded-md text-sm font-medium transition-all duration-300">Features</a>
                                <a href="/#about" className="text-gray-300 hover:text-premium-gold px-3 py-2 rounded-md text-sm font-medium transition-all duration-300">About</a>
                                <button
                                    onClick={() => navigate('/login')}
                                    className="premium-button bg-premium-gold hover:bg-premium-gold-light text-premium-teal px-8 py-2.5 rounded-full font-bold shadow-lg shadow-premium-gold/20 flex items-center gap-2"
                                >
                                    Login
                                    <ChevronRight className="w-4 h-4" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <main className="flex-grow pt-20">
                {children}
            </main>

            {/* Footer */}
            <footer className="bg-premium-dark text-gray-500 py-20 border-t border-white/5 relative z-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-12">
                        <div className="text-center md:text-left">
                            <span className="text-3xl font-black tracking-tighter text-white block">ODAZ<span className="text-premium-gold">APP</span></span>
                            <p className="text-sm mt-4 opacity-50 font-light max-w-xs uppercase tracking-widest">Life, delivered.
                                Order easy eat happy.</p>
                        </div>
                        <div className="flex space-x-12 text-sm font-bold uppercase tracking-widest">
                            <span onClick={() => navigate('/privacy')} className="hover:text-premium-gold transition-all duration-300 cursor-pointer">Privacy</span>
                            <span onClick={() => navigate('/terms')} className="hover:text-premium-gold transition-all duration-300 cursor-pointer">Terms</span>
                            <span onClick={() => navigate('/support')} className="hover:text-premium-gold transition-all duration-300 cursor-pointer">Support</span>
                            <span onClick={() => navigate('/contact')} className="hover:text-premium-gold transition-all duration-300 cursor-pointer">Contact</span>
                        </div>
                    </div>
                    <div className="mt-16 pt-8 border-t border-white/5 text-center text-xs opacity-30">
                        © {new Date().getFullYear()} Odaz Premium Experience. Crafted for excellence.
                    </div>
                </div>
            </footer>
        </div>
    );
}
